import { useState } from "react";
import { LoadingIcon } from "../../assets/icons";
import { useGetAdminAuditLogs } from "../../hooks/Query/useGetAdminAuditLogs";

export default function AdminAuditLog() {
    const [adminName, setAdminName] = useState("");
    const [searchEnabled, setSearchEnabled] = useState(false);
    const [page, setPage] = useState(1);

    const { data: auditData, isFetching: loadingAudit } = useGetAdminAuditLogs({
        admin_name: adminName,
        page,
        enabled: searchEnabled,
    });

    const logs = auditData?.data?.data ?? [];
    const totalPages = auditData?.data?.meta?.last_page ?? auditData?.data?.last_page ?? 1;
    const currentPage = auditData?.data?.meta?.current_page ?? auditData?.data?.current_page ?? 1;
    const total = auditData?.data?.meta?.total ?? auditData?.data?.total ?? 0;

    const handleSearch = () => {
        setPage(1);
        setSearchEnabled(true);
    };

    return (
        <div className="p-6 bg-white min-h-[90vh]">
            <div className="mb-[29px]">
                <label className="block text-[12px] font-medium text-black mb-[10px]">
                    Admin name
                </label>
                <input
                    type="text"
                    value={adminName}
                    onChange={(e) => {
                        setAdminName(e.target.value);
                        setSearchEnabled(false);
                    }}
                    placeholder="Search by admin name"
                    className="w-full md:w-[700px] px-3 py-2 border border-gray-300 rounded-[5px] h-[35px] focus:outline-none focus:ring-1 focus:ring-blue-900 text-sm"
                />
            </div>

            <button
                onClick={handleSearch}
                disabled={loadingAudit || !adminName}
                className={`px-8 py-2 rounded flex items-center justify-center w-[180px] h-[38px] text-sm mb-[70px] text-white transition-all ${!adminName ? "bg-gray-300 cursor-not-allowed" : "bg-[#00305E] hover:bg-blue-800"}`}
            >
                {loadingAudit ? <LoadingIcon /> : "Search"}
            </button>

            {!searchEnabled && (
                <div className="bg-[#F5F5F5] h-[300px] flex items-center justify-center rounded-lg">
                    <p className="text-[#6D6D6D] text-[14px]">Click Search to see records</p>
                </div>
            )}

            {searchEnabled && (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm text-left min-w-[600px]">
                        <thead className="bg-[#F8FAFC] h-[44px]">
                            <tr>
                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Date ↓</th>
                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Membership ID ↓</th>
                                <th className="px-[24px] py-[12px] text-black text-[12px] font-semibold border-b border-[#E9EAEB] whitespace-nowrap">Action ↓</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingAudit ? (
                                <tr>
                                    <td colSpan={3} className="text-center py-10">
                                        <div className="flex justify-center"><LoadingIcon /></div>
                                    </td>
                                </tr>
                            ) : logs.length > 0 ? (
                                logs.map((log) => (
                                    <tr key={log.id} className="border-b hover:bg-blue-50 transition-colors">
                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{log.created_at}</td>
                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{log.membership_id}</td>
                                        <td className="px-[24px] py-[16px] text-[#64748B] text-[14px] whitespace-nowrap">{log.action}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="text-center text-gray-400 py-10">
                                        No records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {totalPages > 1 && (
                        <div className="flex items-center justify-between mt-4 px-2">
                            <p className="text-[12px] text-[#64748B]">
                                Page {currentPage} of {totalPages} — {total} records
                            </p>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => setPage(p => Math.max(1, p - 1))}
                                    disabled={currentPage === 1 || loadingAudit}
                                    className={`px-3 py-1 rounded text-[12px] border transition-all ${currentPage === 1 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                >
                                    Previous
                                </button>
                                <button
                                    onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                    disabled={currentPage === totalPages || loadingAudit}
                                    className={`px-3 py-1 rounded text-[12px] border transition-all ${currentPage === totalPages ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-[#00305E] text-[#00305E] hover:bg-blue-50"}`}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}